<template lang="pug">
#modal-consolidar-lote-pssc
    el-dialog(
        :title="$t('mensagens.pssc.telaIncluirTerritorios.incluirTerritorios')",
        :width='width',
        :visible.sync='show_',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        custom-class='no-box-shadow',
        show-close,
        @close='closeDialog()'
    )

        div.modal-incluir-territorio-content(style='display: flex; flex-direction: column')
            .modal-lote-container
                div.modal-texto-bold(style='margin-bottom: 3px;') {{ $t('mensagens.pssc.telaIncluirTerritorios.escolhaComoProsseguir') }}
                div.modal-selecao-lote
                    el-radio.selecao-lote(
                        v-model='modoSelecaoLote',
                        :disabled='!opcoesLotes',
                        label='ESCOLHER_LOTE',
                        @change='alterarMetodoConsolidacao',
                        v-loading='loading.lote'
                    ) {{ $t('mensagens.pssc.telaIncluirTerritorios.escolherLoteExistente') }}
                    
                    .modal-escolha-lote(
                        v-if='modoSelecaoLote==="ESCOLHER_LOTE"'
                    )
                        el-select.el-select_lote(
                            v-model='lote',
                            @change='habilitarConsolidarLote',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ nome, id } in opcoesLotes',
                                :key='id + nome',
                                :label='nome',
                                :value='id'
                            )
                        div.cadastro-campo-erro(v-if='lote===""') {{ $t('mensagens.comuns.campoObrigatorio') }}
                
                div.modal-selecao-lote
                    el-radio.selecao-lote(
                        v-model='modoSelecaoLote',
                        label='NOVO_LOTE',
                        @change='alterarMetodoConsolidacao'
                    ) {{ $t('mensagens.pssc.telaIncluirTerritorios.criarNovoLote') }}

                    .modal-novo-lote(v-if='modoSelecaoLote==="NOVO_LOTE"')
                        el-input.el-input_lote(
                            :placeholder="$t('mensagens.pssc.telaIncluirTerritorios.placeholderNovoLote')",
                            v-model='nomeNovoLote',
                            @input='habilitarConsolidarLote',
                            clearable,
                            show-word-limit,
                            maxlength="50"
                        )
                        div.cadastro-campo-erro(v-if='nomeNovoLote===""') {{ $t('mensagens.comuns.campoObrigatorio') }}
                        div.cadastro-campo-erro(v-if='mostrarMensagemErroLote')
                            i.el-icon-info {{ $t('mensagens.pssc.telaIncluirTerritorios.erroInserirLoteExistente') }}

        .dialog-footer(slot='footer')
            el-button.outline-button(
                type='outline',
                size='mini',
                @click='closeDialog'
            ) {{ $t('mensagens.comuns.cancelar') }}
            el-button.primary-button(
                type='primary',
                size='mini',
                :disabled='habilitarConsolidar',
                @click='processarNovoLote'
            ) {{ $t('mensagens.pssc.telaIncluirTerritorios.consolidarLote') }}
</template>

<script>
import PSSCService from '@/services/PSSCService';

export default {
    name: 'ModalConsolidarLote',
    emits: ['showNotificacaoSucesso'],
    components: { },

    props: {
        show: {
            type: Boolean,
            default: false,
            required: true
        },
        selecionarTodos: {
            type: Boolean,
            required: true
        },
        selecao: {
            type: Array,
            required: true
        },
        filtros: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            carregando: false,
            mostrarMensagemErroLote: false,
            modoSelecaoLote: 'NOVO_LOTE',
            lote: null,
            nomeNovoLote: null,
            loading: {
                lote: false
            },
            opcoesLotes: null,

            show_: false,
            nomeNovoLote_: null,
            habilitarConsolidar: true,
            modoConsolidar: null,
            idLote: null,
            width: '50%',
            dadosCadastroPSSC: {
                idLote: null,
                selecionarTodos: null,
                selecao: null
            }
        };
    },

    watch: {
        show: {
            handler() {
                this.show_ = this.show;
                this.dadosCadastroPSSC.selecionarTodos = this.selecionarTodos;
                this.dadosCadastroPSSC.selecao = this.selecao;
                this.width = '50%';
                if (this.show) {
                    this.buscarLotes();
                }
            },
            immediate: true
        }
    },

    methods: {
        closeDialog() {
            this.show_ = false;
            this.dadosCadastroPSSC.idLote = null;
            this.$emit('closeDialog');
        },
        async processarNovoLote() {
            if (this.modoConsolidar === 'ESCOLHER_LOTE') {
                this.dadosCadastroPSSC.idLote = this.idLote;
                await this.consolidarLote();
            } else if (this.modoConsolidar === 'NOVO_LOTE') {
                await PSSCService.inserirLote({'nome': this.nomeNovoLote_})
                    .then(({data}) => {
                        this.dadosCadastroPSSC.idLote = data.id;
                        this.consolidarLote();
                    })
                    .catch((error) => {
                        if (error.response.data.message === 'LOTE_EXISTENTE') {
                            this.mostrarMensagemErroLote = true;
                            document.getElementsByClassName('el-input_lote')[0].classList.add('campo-obrigatorio');
                        } else {
                            this.$notify.error({
                                message: this.$t('mensagens.pssc.telaIncluirTerritorios.erroInserirLote')
                            });
                        }
                    })
                    .finally(() => {
                        setTimeout(() => {
                            document.getElementsByClassName('el-input_lote')[0].classList.remove('campo-obrigatorio');
                            this.mostrarMensagemErroLote = false;
                        }, 5000);
                    });
            }
        },
        habilitarConsolidarLote() {
            if (this.modoSelecaoLote === 'ESCOLHER_LOTE') {
                this.habilitarBotaoConsolidar((this.lote && this.lote !== ''), null, this.modoSelecaoLote, this.lote);
            } else {
                this.habilitarBotaoConsolidar((this.nomeNovoLote && this.nomeNovoLote !== ''), this.nomeNovoLote, this.modoSelecaoLote, null);
            }
        },
        alterarMetodoConsolidacao() {
            this.lote = null;
            this.nomeNovoLote = null;
            this.habilitarConsolidarLote();
        },
        async buscarLotes() {
            this.loading.lote = true;
            try {
                const { data } = await PSSCService.buscarLotes();
                if (data.itens.length > 0) {
                    this.opcoesLotes = data.itens;
                }
            } catch {
                this.$notify.error({
                    message: 'Não foi possível buscar os lotes.'
                });
            } finally {
                this.loading.lote = false;
            }
        },

        consolidarLote() {
            try {
                PSSCService.consolidarLote({
                    ...this.filtros,
                    ...this.dadosCadastroPSSC
                });
                this.closeDialog();
                this.$emit('showNotificacaoSucesso');
            } catch (err) {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaIncluirTerritorios.erroConsolidarLote')
                });
            }
        },
        habilitarBotaoConsolidar(statusBotao, nomeNovoLote, modo, idLote) {
            this.habilitarConsolidar = !statusBotao;
            this.modoConsolidar = modo;
            this.idLote = idLote;

            if (nomeNovoLote) this.nomeNovoLote_ = nomeNovoLote;
        }
    }
};
</script>

<style lang="scss">
#modal-consolidar-lote-pssc {

    .modal-incluir-territorio-content{
        height: fit-content;
    }
    .modal-lote-container {
        width: 100%;
        height: fit-content;
        font-size: 14px;
        margin: 14px 4px;
        .modal-selecao-lote {
            display: flex;
            flex-direction: column;
            margin-top: 8px;
            .selecao-lote {
                font-weight: normal !important;
            }

            .selecao-lote.is-checked {
                .el-radio__label {
                    color: var(--secondary-two) !important;
                }
            }
        }
    }

    .modal-escolha-lote {
        height: fit-content;
        .el-select_lote {
            width: 100%;
            margin: 8px 0;
        }
    }
    .modal-novo-lote {
        height: fit-content;
        .el-input_lote{
            width: 100%;
            margin: 8px 0;
        }
    }

    .cadastro-campo-erro {
        color: #DC362E;
        font-size: 12px;
        padding: 5px 0;
    }
    .modal-texto-bold {
        font-weight: 500;
    }

    .el-dialog__footer {
        margin-top: 0;
        text-align: right;
        border-top: solid 2px #e7e7e7;
        background-color: #ffffff;

        .dialog-footer {
            display: flex;
            justify-content: flex-end;
            gap: 16px;
        }
    }

    .el-dialog__close {
        color: #3B3B3B;
        &:before {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .outline-button {
        margin: 0px !important;
    }

    .primary-button {
        margin: 0px !important;
    }

    .modal-text {
        font-family: 'Roboto', 'sans serif';
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        padding-bottom: 8px;
    }

    .el-dialog__body {
        max-height: 525px;
        overflow-y: auto;
    }

    .el-dialog__body {
        padding: 20px;
        background-color: #ffffff;
        padding-bottom: 0;
        span {
            color: #3b3b3b;
        }
    }

    .el-dialog__header {
        padding: 15px 20px !important;
        background-color: #e9e9e9;
        .el-dialog__title {
            color: #00413c;
            font-weight: 600;
            font-size: 18px;
            line-height: 22px;
        }
    }

    .el-dialog__body {
        max-height: 525px;
        padding: 15px;
    }

    .font-bold {
        font-weight: 600;
    }

    .el-divider--horizontal {
        margin: 15px 0 8px 0;
    }
}
</style>
